import { Grid, Typography } from '@material-ui/core'
import { GRAY_COLORS } from 'asterX-UI'
import { Nodata } from 'asterX-UI/Icons/Nodata'

export const NotFound = ({ title = 'Нет данных' }) => {
  return (
    <Grid container justifyContent="center">
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '20px' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 24,
            height: 24,
            padding: 12,
            borderRadius: 10,
            border: `1px solid ${GRAY_COLORS[200]}`,
            backgroundColor: '#fff'
          }}
        >
          <Nodata />
        </div>

        <Typography
          variant="h6"
          style={{ display: 'flex', alignItems: 'center', marginTop: 10, color: GRAY_COLORS[600] }}
        >
          {title}
        </Typography>
      </div>
    </Grid>
  )
}
